import * as React from "react"
import {SvgFunction} from "@web-libs/ui/svgs/types";
const MenuIcon:SvgFunction = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width ?? 32}
        height={props.height ?? 32}
        viewBox="0 0 32 32"
    >
        <path
            fill={props.fill ?? "#000"}
            d="M30.667 14.111H1.333C.597 14.111 0 14.733 0 15.5s.597 1.389 1.333 1.389h29.334c.736 0 1.333-.622 1.333-1.389s-.597-1.389-1.333-1.389ZM30.667 3H1.333C.597 3 0 3.622 0 4.389s.597 1.389 1.333 1.389h29.334c.736 0 1.333-.622 1.333-1.39C32 3.623 31.403 3 30.667 3ZM30.667 25.222H1.333c-.736 0-1.333.622-1.333 1.389S.597 28 1.333 28h29.334C31.403 28 32 27.378 32 26.61s-.597-1.389-1.333-1.389Z"
        />
    </svg>
)
export default MenuIcon
